import { render, staticRenderFns } from "./clinic-situation-form.vue?vue&type=template&id=7bc1e172&scoped=true&lang=pug&"
import script from "./clinic-situation-form.vue?vue&type=script&lang=ts&"
export * from "./clinic-situation-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc1e172",
  null
  
)

export default component.exports